import React from "react";
import { FiArrowUpRight, FiChevronDown } from "react-icons/fi";
import backgroundImage from "../../assets/hands-indian-bride-groom-intertwined-together-making-authentic-wedding-ritual.jpg";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative h-screen w-full overflow-hidden group"
    >
      {/* Background Image with Zoom Effect */}
      <img
        src={backgroundImage}
        alt="Studio44 Photography"
        className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-10000 ease-out"
      />

      {/* Premium Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      
      {/* Bottom Gradient Fade */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

      {/* Decorative Blur Elements */}
      <div className="absolute top-1/4 right-1/3 w-96 h-96 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 flex h-full items-center">
        <div className="mx-auto max-w-7xl px-6 w-full">
          {/* Badge */}
          <div className="flex items-center gap-3 mb-8 animate-fade-in">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <span className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
              Studio44 Photography
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="max-w-4xl text-6xl md:text-7xl lg:text-8xl font-black leading-[1.1] text-white mb-8 animate-slide-up">
            Every Picture
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-amber-500">
              Tells a Story
            </span>
          </h1>

          {/* Subtitle */}
          <p className="mt-6 max-w-2xl text-lg md:text-xl text-gray-300 leading-relaxed mb-12 animate-slide-up animation-delay-100">
            Capturing timeless moments from weddings, baby showers, birthdays, 
            maternity shoots, and every special celebration that deserves to be 
            preserved forever.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up animation-delay-200">
            {/* Primary Button */}
            <a
              href="#portfolio"
              className="group/btn px-8 py-4 bg-white text-black font-bold uppercase text-sm tracking-[2px] transition-all duration-300 hover:bg-amber-400 hover:shadow-2xl hover:shadow-amber-400/30 inline-flex items-center justify-center gap-2 relative overflow-hidden"
            >
              <span className="relative z-10 flex items-center gap-2">
                View Portfolio
                <FiArrowUpRight className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform duration-300" size={16} />
              </span>
            </a>

            {/* Secondary Button */}
            <a
              href="#booking"
              className="group/btn px-8 py-4 border-2 border-white text-white font-bold uppercase text-sm tracking-[2px] transition-all duration-300 hover:bg-white hover:text-black hover:shadow-2xl hover:shadow-white/20 inline-flex items-center justify-center gap-2 backdrop-blur-sm bg-white/5"
            >
              <span className="relative z-10 flex items-center gap-2">
                Book a Session
                <FiArrowUpRight className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform duration-300" size={16} />
              </span>
            </a>
          </div>

          {/* Stats or Quick Info */}
          <div className="mt-16 flex flex-wrap gap-8 md:gap-16 animate-slide-up animation-delay-300">
            <div className="flex flex-col">
              <span className="text-3xl md:text-4xl font-black text-amber-400">500+</span>
              <span className="text-sm uppercase tracking-[2px] text-gray-400 font-medium mt-2">Happy Clients</span>
            </div>
            <div className="flex flex-col">
              <span className="text-3xl md:text-4xl font-black text-amber-400">10+</span>
              <span className="text-sm uppercase tracking-[2px] text-gray-400 font-medium mt-2">Years Experience</span>
            </div>
            <div className="flex flex-col">
              <span className="text-3xl md:text-4xl font-black text-amber-400">2K+</span>
              <span className="text-sm uppercase tracking-[2px] text-gray-400 font-medium mt-2">Photos Captured</span>
            </div>
          </div>
        </div>
      </div>

      {/* Animated Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 cursor-pointer group/scroll hover:opacity-100 opacity-70 transition-opacity">
        <div className="flex flex-col items-center gap-4">
          <span className="text-xs uppercase tracking-[3px] text-gray-400 font-medium">Scroll to explore</span>
          <div className="flex flex-col items-center gap-2 animate-bounce">
            <div className="w-6 h-10 border-2 border-amber-400 rounded-full flex justify-center p-2">
              <div className="w-1 h-2 bg-amber-400 rounded-full animate-pulse" />
            </div>
            <FiChevronDown className="text-amber-400 animate-bounce" size={20} />
          </div>
        </div>
      </div>

      {/* Vignette Effect */}
      <div className="absolute inset-0 rounded-lg shadow-[inset_0_0_60px_rgba(0,0,0,0.4)] pointer-events-none" />
    </section>
  );
};

export default Hero;